(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataDialogController', ObservedDataDialogController);

    ObservedDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ObservedData'];

    function ObservedDataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ObservedData) {
        var vm = this;

        vm.observedData = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.observedData.id !== null) {
                ObservedData.update(vm.observedData, onSaveSuccess, onSaveError);
            } else {
                ObservedData.save(vm.observedData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:observedDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.settlementDate = false;
        vm.datePickerOpenStatus.tradeDate = false;
        vm.datePickerOpenStatus.inceptionDate = false;
        vm.datePickerOpenStatus.maturityDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
